import {CsvConfigJsonResult} from '../synoptic-configuration-csv-types';

export function isShowPopupArgs(obj: any): CsvConfigJsonResult {
  let valid = true;
  let errors = [];


  if (obj.component === undefined) {
    valid = false;
    errors.push({code: 'notExist', key: 'component'});
  } else if (typeof obj.component !== 'string') {
    valid = false;
    errors.push({code: 'notText', key: 'component', value: obj.component});
  }

  if (obj.file === undefined) {
    valid = false;
    errors.push({code: 'notExist', key: 'file'});
  } else if (typeof obj.file !== 'string') {
    valid = false;
    errors.push({code: 'notText', key: 'file', value: obj.file});
  }

  return {result: valid, errors: errors};
}
